import React, { useEffect, useCallback } from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import Text from 'design-system/Text';
import InfoCard from 'design-system/InfoCard';
import { hitSlop, Spacer } from 'design-system';
import Links from 'utils/links';
import { useFetchOld, muteAll } from 'hooks/useFetch';
import { useAppSelector } from 'store/hooks';
import { selectPendingTopupsFlag } from '../reducers/selectors';
import { getPendingTopups } from '../actions';
const strings = {
    // injecting non-breaking space to ensure "within the next few hours" always stays on one line
    topupPending: 'Your top-up is pending. It should be available within the next few hours.',
};
/**
 * Renders nothing if there are no pending topup payments in cache.
 *
 * @param marginBottom When set, will add standard spacing to the bottom of this view, if the view gets rendered.
 */
const TopupPendingWarning = ({ onLight, marginBottom }) => {
    const pendingTopupsExist = useAppSelector(selectPendingTopupsFlag);
    const [, , , fetch] = useFetchOld(muteAll);
    useEffect(() => {
        fetch(getPendingTopups());
    }, []);
    const handleLearnMore = useCallback(() => {
        Links.openDepositFAQ();
    }, []);
    if (pendingTopupsExist) {
        return (<>
        <Spacer h={8}/>
        <InfoCard onLight={onLight}>
          <Text TextThin-14 Secondary>
            {strings.topupPending}
          </Text>
          <View style={styles.row}>
            <TouchableOpacity hitSlop={hitSlop} onPress={handleLearnMore}>
              <Text Primary Text-14>
                Learn more
              </Text>
            </TouchableOpacity>
          </View>
        </InfoCard>
        {marginBottom ? <Spacer h={16}/> : <Spacer h={8}/>}
      </>);
    }
    return null;
};
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
    },
});
export default React.memo(TopupPendingWarning);
